import { Pane, TextInputField, Heading, Button, majorScale, toaster } from 'evergreen-ui';
import { NewPersonIcon, Select, FormField } from 'evergreen-ui';
import { createGuest } from '../services/guestsServices';

const AddGuestForm = ({ newGuest, setNewGuest, setGuests }) => {

    const defaultGuest = {
        nome: '',
        cognome: '',
        sesso: 'M',
        data_nascita: '',
        luogo_nascita: '',
        residenza: '',
        domicilio: '',
        motivazione: 'minori stranieri non accompagnati',
    };

    const guest = { ...defaultGuest, ...newGuest };

    const handleAddGuest = async () => {
        try {
            const addedGuest = await createGuest(guest);
            setGuests((prevGuests) => [...prevGuests, addedGuest]);
            setNewGuest(defaultGuest);
            toaster.success('Ospite aggiunto con successo');
        } catch (error) {
            console.error('Errore durante l\'aggiunta di un nuovo ospite:', error);
            toaster.danger('Errore durante l\'aggiunta di un nuovo ospite');
        }
    };

    return (
        <Pane marginTop={majorScale(4)}>
            <Heading size={600} marginBottom={16}>
                Aggiungi nuovo ospite
            </Heading>
            <TextInputField
                label="Nome"
                placeholder="Inserisci il nome del nuovo ospite..."
                value={guest.nome}
                onChange={(e) => setNewGuest({ ...guest, nome: e.target.value })}
                marginBottom={16}
            />
            <TextInputField
                label="Cognome"
                placeholder="Inserisci il cognome del nuovo ospite..."
                value={guest.cognome}
                onChange={(e) => setNewGuest({ ...guest, cognome: e.target.value })}
                marginBottom={16}
            />
            <FormField
                label="Sesso"
                marginBottom={16}
            >
                <Select
                    id="sex-select"
                    value={guest.sesso}
                    onChange={(e) => setNewGuest({ ...guest, sesso: e.target.value })}
                >
                    <option value="M">Maschio</option>
                    <option value="F">Femmina</option>
                </Select>
            </FormField>
            <TextInputField
                label="Data di nascita"
                type="date"
                value={guest.data_nascita}
                onChange={(e) => setNewGuest({ ...guest, data_nascita: e.target.value })}
                marginBottom={16}
                max={new Date().toISOString().split('T')[0]}
            />
            <TextInputField
                label="Luogo di nascita"
                placeholder="Inserisci il luogo di nascita del nuovo ospite..."
                value={guest.luogo_nascita}
                onChange={(e) => setNewGuest({ ...guest, luogo_nascita: e.target.value })}
                marginBottom={16}
            />
            <TextInputField
                label="Residenza"
                placeholder="Inserisci la residenza del nuovo ospite..."
                value={guest.residenza}
                onChange={(e) => setNewGuest({ ...guest, residenza: e.target.value })}
                marginBottom={16}
            />
            <TextInputField
                label="Domicilio"
                placeholder="Inserisci il domicilio del nuovo ospite..."
                value={guest.domicilio}
                onChange={(e) => setNewGuest({ ...guest, domicilio: e.target.value })}
                marginBottom={16}
            />
            <FormField
                label="Motivazione"
                marginBottom={16}
            >
                <Select
                    id="motivation-select"
                    value={guest.motivazione}
                    onChange={(e) => setNewGuest({ ...guest, motivazione: e.target.value })}
                >
                    <option value="minori stranieri non accompagnati">Minori stranieri non accompagnati</option>
                    <option value="penale">Penale</option>
                    <option value="sociale">Sociale</option>
                    <option value="emergenza">Emergenza</option>
                </Select>
            </FormField>
            <Pane marginTop="0.5rem">
                <Button appearance="primary" intent="success" onClick={handleAddGuest} marginTop={majorScale(2)}>
                    Aggiungi ospite <NewPersonIcon marginLeft={8} />
                </Button>
            </Pane>
        </Pane>
    );
};

export default AddGuestForm;